module.exports = __webpack_public_path__ + "static/media/managers-guide4.af2f1e0d.png";